import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

export const OneOneInquiryPublish = () => {
    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">1:1문의 검색</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label for="" className="form-label frm_label">상태</label>
                            <select className="form-select">
                                <option>수주</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="frm_row">
                            <label for="" className="form-label frm_label">등록기간</label>
                            <div className="frm_field input_date">
                                <input type="date" className="form-control" />
                                <span className="txt_range">~</span>
                                <input type="date" className="form-control me-0" />
                                <button className="btn btn-info btn_search">
                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">1:1 문의 목록(<span>13</span>건)</h6>
                    <div className="table_toolbar">
                        <button className="btn btn-outline-dark w-100px px-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt="" />선택삭제</button>
                    </div>
                </div>

                <div className="table_scroll">
                    <table className="table table-bordered my_table">
                        <thead>
                            <tr>
                                <th rowSpan={2} style={{ width: "4.4%" }}>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                        />
                                    </div>
                                </th>
                                <th style={{ width: "8.8%" }} rowSpan={2}>문의 일자</th>
                                <th style={{ width: "8.8%" }} rowSpan={2}>유형</th>
                                <th style={{ width: "17.6%" }} colSpan={2}>제품</th>
                                <th style={{ width: "25.15%" }} rowSpan={2}>제목</th>
                                <th style={{ width: "8.8%" }} rowSpan={2}>기술지원</th>
                                <th style={{ width: "17.6%" }} colSpan={2}>고객</th>
                                <th rowSpan={2}>상태</th>
                            </tr>
                            <tr>
                                <th style={{ width: "8.8%" }}>벤더</th>
                                <th style={{ width: "8.8%" }}>카테고리</th>
                                <th style={{ width: "8.8%" }}>고객사</th>
                                <th style={{ width: "8.8%" }}>담당자</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, index) => (
                                <tr className={item == 9 ? "lightblue" : ""}>
                                    <td className="text-center">
                                        <div className="checkbox_outer"><input
                                            className="form-check-input"
                                            type="checkbox"
                                        /></div>
                                    </td>
                                    <td className="text-center">2024.01.10</td>
                                    <td className="text-center">설치</td>
                                    <td className="text-center">MS</td>
                                    <td className="text-center">Win11</td>
                                    <td>오프라인 전화 인증은 어떻게 하나요?</td>
                                    <td className="text-center">미지원</td>
                                    <td className="text-center">(주) 구구구</td>
                                    <td className="text-center">김영리 대리</td>
                                    <td className="text-center">접수</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="pagination-container">
                    <ul>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                alt="First Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                alt="Previous Page"
                                className=""
                            />
                        </li>
                        <li className="active">1</li>
                        <li className="">2</li>
                        <li className="">3</li>
                        <li className="">4</li>
                        <li className="">5</li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                alt="Next Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                alt="Last Page"
                                className=""
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}